import React, { FormEvent, useContext, useState } from 'react';
import { Btn } from '../common/Btn';
import { geoCode } from '../../utils/geocoding';
import { CoordinatesContext } from '../../context/coordinate.context';
import { useNavigate } from 'react-router-dom';
import env from 'react-dotenv';

export function AddAdvert() {
    const { coordinates, setCoordinates } = useContext(CoordinatesContext);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [mistake, setMistake] = useState(false);

    const [form, setForm] = useState({
        name: '',
        description: '',
        price: 0,
        url: '',
        miasto: '',
        ulica: '',
        numer: 1,
    })

    const formUpdate = (key: string, value: string | number) => {
        setForm(prevForm => ({
            ...prevForm,
            [key]: value,
        }));
    }

    async function saveAdvert(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const address = `${form.miasto}, ${form.ulica} ${form.numer}`
        try {
            const { lat, lon } = await geoCode(address);

            const advert = {
                name: form.name,
                description: form.description,
                price: form.price,
                url: form.url,
                lat,
                lon
            }
            const list = [lat, lon]
            setCoordinates(list);

            console.log('FORM', list);

            const options = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(advert)
            }
            setLoading(true);

            const add = await fetch(`https://mapsapi.nextwww.pl/card`, options)
            const addResponse = await add.json()

            navigate('/');

        } catch (e) {
            setMistake(true);
        }

    }

    if (loading) {
        return <h2>Trwa dodawanie ogłoszenia...</h2>
    }

    return (
        <>
            <main className='container mt-5'>
                <div className='columns is-centered'>
                    <div className="column is-8">
                        <h1>FORMULARZ</h1>
                        <form action="" onSubmit={saveAdvert}>
                            <label className="label mt-5">Tytuł ogłoszenia</label>
                            <div className="control">
                                <input
                                    className="input mb-5"
                                    name="name"
                                    type="text"
                                    placeholder="Tytuł"
                                    required
                                    value={form.name}
                                    onChange={e => formUpdate('name', e.target.value)}
                                />
                            </div>
                            <label className="label">Opis</label>
                            <textarea
                                className="input mb-5"
                                name="description"
                                placeholder="Opis"
                                value={form.description}
                                onChange={e => formUpdate('description', e.target.value)}
                            >
                            </textarea>

                            <label className="label">Cena</label>
                            <input
                                className="input mb-5"
                                name="price"
                                type="number"
                                placeholder="Cena"
                                min={0}
                                max={9999999}
                                value={form.price}
                                onChange={e => formUpdate('price', Number(e.target.value))}
                            />

                            <label className="label">Link</label>
                            <input
                                className="input mb-5"
                                name="url"
                                type="url"
                                placeholder="Link"
                                value={form.url}
                                onChange={e => formUpdate('url', e.target.value)}
                            />
                            <label className="label">adres</label>
                            <div className='columns'></div>
                            <input
                                className="input mb-5 column"
                                name="Miasto" type="text"
                                placeholder="Miasto"
                                required
                                value={form.miasto}
                                onChange={e => formUpdate('miasto', e.target.value)}
                            />
                            <input
                                className="input mb-5 column"
                                name="ulica" type="text"
                                placeholder="Ulica"
                                required
                                value={form.ulica}
                                onChange={e => formUpdate('ulica', e.target.value)}
                            />
                            <input
                                className="input mb-5 column"
                                name="numer" type="number"
                                placeholder="numer"
                                required
                                value={form.numer}
                                onChange={e => formUpdate('numer', e.target.value)}
                            />

                            <div className="buttons">
                                <Btn classes={["is-primary", "is-rounded button"]} name={'Wyślij'} />
                            </div>
                        </form>
                        {!!mistake && <p>Coś poszło nie tak. Prawdopodobnie nie znaleziono adresu.</p>}
                    </div>
                </div>
            </main>
        </>
    );
}